// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-content {
  min-height: calc(var(--d-spacing-double) * 2.5);
  width: 100%;
  margin: 0;
  background-color: white;
}

.header-content-container {
  padding: var(--d-spacing-single);
}

.header-buttons {
  display: flex;
  align-items: center;
}

.side-padding {
  padding-left: var(--d-spacing-single);
  padding-right: var(--d-spacing-single);
}

.space-between {
  justify-content: space-between;
}

.reference-bar-buttons {
  display: flex;
  padding-right: var(--d-spacing-single);
}

.title {
  font-size: 19px;
  font-weight: bold;
  color: var(--ion-color-primary);
  line-height: 130%;
  padding-top: var(--d-spacing-single);
}

.center {
  text-align: center;
}

.subtitle {
  font-size: 16px;
  font-weight: 500;
  color: var(--ion-color-primary);
  line-height: 150%;
  padding-top: var(--d-spacing-half);
}

.subtitle_h1 {
  font-size: 19px;
  font-weight: bold;
  color: var(--ion-color-primary);
  line-height: 130%;
  padding-top: var(--d-spacing-half);
}

.subtitle_h1_centered {
  font-size: 19px;
  font-weight: bold;
  color: var(--ion-color-primary);
  line-height: 130%;
  padding-top: var(--d-spacing-half);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
}

.icon-container {
  display: flex;
  margin-bottom: var(--d-spacing-single);
  align-items: center;
}

.back-button {
  font-size: 19px;
  font-weight: bold;
  color: var(--ion-color-primary);
  line-height: 130%;
  padding-right: var(--d-spacing-single);
  height: 23px;
  width: 28px;
}

.close-x-icon {
  font-size: 19px;
  font-weight: bold;
  color: var(--ion-color-primary);
  line-height: 130%;
  height: 28px;
  width: 28px;
}

.cancel-project-ellipsis {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  position: relative;
}

.hint {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/app/common/components/dwin-header/dwin-header.component.scss","webpack://./src/mixins.scss"],"names":[],"mappings":"AAEA;EACE,+CAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;AADF;;AAIA;EACE,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,qCAAA;EACA,sCAAA;AADF;;AAIA;EACE,8BAAA;AADF;;AAIA;EACE,aAAA;EACA,sCAAA;AADF;;AAIA;EC/BI,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;ED8BF,oCAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;ECjCI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;EDgCF,kCAAA;AAKF;;AAFA;EC7CI,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;ED4CF,kCAAA;AAQF;;AALA;EClDI,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;EDiDF,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AAWF;;AARA;EACE,aAAA;EACA,sCAAA;EACA,mBAAA;AAWF;;AARA;EClEI,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;EDiEF,sCAAA;EACA,YAAA;EACA,WAAA;AAcF;;AAXA;ECzEI,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;EDwEF,YAAA;EACA,WAAA;AAiBF;;AAdA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAiBF;;AAdA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAiBF","sourcesContent":["@import \"src/mixins.scss\";\n\n.header-content {\n  min-height: calc(var(--d-spacing-double) * 2.5);\n  width: 100%;\n  margin: 0;\n  background-color: white;\n}\n\n.header-content-container {\n  padding: var(--d-spacing-single);\n}\n\n.header-buttons {\n  display: flex;\n  align-items: center;\n}\n\n.side-padding {\n  padding-left: var(--d-spacing-single);\n  padding-right: var(--d-spacing-single);\n}\n\n.space-between {\n  justify-content: space-between;\n}\n\n.reference-bar-buttons {\n  display: flex;\n  padding-right: var(--d-spacing-single);\n}\n\n.title {\n  @include h1-style;\n  padding-top: var(--d-spacing-single);\n}\n\n.center {\n  text-align: center;\n}\n\n.subtitle {\n  @include p1-style;\n  padding-top: var(--d-spacing-half);\n}\n\n.subtitle_h1 {\n  @include h1-style;\n  padding-top: var(--d-spacing-half);\n}\n\n.subtitle_h1_centered {\n  @include h1-style;\n  padding-top: var(--d-spacing-half);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  text-align: center;\n}\n\n.icon-container {\n  display: flex;\n  margin-bottom: var(--d-spacing-single);\n  align-items: center;\n}\n\n.back-button {\n  @include h1-style;\n  padding-right: var(--d-spacing-single);\n  height: 23px;\n  width: 28px;\n}\n\n.close-x-icon {\n  @include h1-style;\n  height: 28px;\n  width: 28px;\n}\n\n.cancel-project-ellipsis {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n  position: relative;\n}\n\n.hint {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  position: relative;\n}\n","@mixin h1-style {\n    font-size: 19px;\n    font-weight: bold;\n    color: var(--ion-color-primary);\n    line-height: 130%;\n}\n\n@mixin p1-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p1-berry-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n\n@mixin p1-white-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: white;\n    line-height: 150%;\n}\n\n@mixin p2-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p2-berry-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
